import { SystemStyleObject } from '@betterment/samba-styled-system/types';

export const tableBorderStyles: SystemStyleObject = {
  borderWidth: 'thin',
  borderStyle: 'solid',
  borderColor: 'border',
  borderCollapse: 'separate',
  borderSpacing: '0px',
};

export const cellBorderStyle: SystemStyleObject = {
  borderLeftStyle: 'none',
  borderRightStyle: {
    base: 'solid',
    _last: 'none',
  },
  borderBottomStyle: 'solid',
  borderWidth: 'thin',
  borderColor: 'border',
};

export const lastRowCellStyle: SystemStyleObject = {
  ...cellBorderStyle,
  borderBottomStyle: 'none',
};
